module.exports = __webpack_public_path__ + "img/grey.6b9d4d5.svg";